import React from "react";
import { Check, Clock } from "lucide-react";

// Live delivery ETA countdown. `etaMin` comes from the server and refreshes on poll;
// between polls it ticks down locally for a smooth countdown feel.
export function EtaCountdown({ etaMin, testId }) {
  const [remaining, setRemaining] = React.useState(Math.max(0, Math.round((etaMin || 0) * 60)));
  React.useEffect(() => {
    setRemaining(Math.max(0, Math.round((etaMin || 0) * 60)));
    const t = setInterval(() => setRemaining((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [etaMin]);
  const m = Math.floor(remaining / 60);
  const s = remaining % 60;
  const label = remaining <= 0 ? "Any moment" : m >= 1 ? `${m}:${String(s).padStart(2, "0")}` : `${s}s`;
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-brand px-2.5 py-1 text-[11px] font-bold text-white" data-testid={testId}>
      <Clock className="h-3 w-3" /> {label}
    </span>
  );
}

const STEPS = ["Placed", "Accepted", "Preparing", "On the way"];

// Map a food-order status to a step index (0..3). Terminal states handled by caller.
export function orderStepIndex(status) {
  switch (status) {
    case "awaiting_payment":
    case "placed":
    case "finding_partner":
      return 0;
    case "accepted":
      return 1;
    case "preparing":
      return 2;
    case "ready":
      return 2;
    case "out_for_delivery":
      return 3;
    case "delivered":
      return 4;
    default:
      return 0;
  }
}

// Compact step tracker: placed → accepted → preparing → on the way.
export default function OrderProgress({ status, testId }) {
  const active = orderStepIndex(status);
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {STEPS.map((label, i) => {
        const done = i < active;
        const current = i === active;
        return (
          <React.Fragment key={label}>
            <div className="flex flex-col items-center gap-0.5">
              <span className={`flex h-4 w-4 items-center justify-center rounded-full text-[8px] font-bold transition-colors ${done ? "bg-brand text-white" : current ? "bg-brand/15 text-brand ring-2 ring-brand" : "bg-surface-200 text-ink-muted"}`}>
                {done ? <Check className="h-2.5 w-2.5" /> : i + 1}
              </span>
              <span className={`text-[9px] font-semibold ${current ? "text-brand" : done ? "text-ink-soft" : "text-ink-muted"}`}>{label}</span>
            </div>
            {i < STEPS.length - 1 && <span className={`mb-3 h-0.5 flex-1 rounded-full ${i < active ? "bg-brand" : "bg-surface-200"}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
}
